/* eslint-disable react/no-danger */

import React, { useContext, useLayoutEffect, useRef, useState } from 'react';
import cn from '@/utils/cn';
import DndAnswerContext from 'components/common/Context';
import styles from './TextArea.module.scss';
import { getTextContent, positionedContainerStyle, sizedContainerStyle } from '../../utils';
import useVocabularyStore from '../../useVocabularyStore';

interface TextAreaType {
  id: string;
  inBuilder?: boolean;
  text: string;
  left: number;
  top: number;
  height?: number;
  vocabId?: string;
  width?: number;
}

const TextArea = ({ height, id, inBuilder = false, text, left, top, width, vocabId }: TextAreaType) => {
  const textAreaContainerRef = useRef();
  const label = `Text area ${id.toUpperCase()}`;

  const vocabularyTerms = useVocabularyStore(state => state.vocabularyTerms);
  const vocabLoading = useVocabularyStore(state => state.loading);
  const [textContent, setTextContent] = useState('');

  const { vocabLinkOption } = useContext(DndAnswerContext);

  useLayoutEffect(() => {
    setTextContent(getTextContent(vocabId, vocabularyTerms, vocabLoading, text, vocabLinkOption));
  }, [vocabId, vocabularyTerms, vocabLoading, text]);

  return (
    <div
      aria-label={label}
      className={cn({ 'tw-text-base tw-leading-4 text-area': !!vocabId })}
      role="button"
      style={positionedContainerStyle(left, top, width, height)}
      tabIndex={0}
    >
      <div style={sizedContainerStyle()}>
        <div
          ref={textAreaContainerRef}
          className={styles.textareaContainer}
        >
          {vocabLinkOption === 'images' ? (
            <div className={styles.imageCard}>
              <div className={styles.imageContainer}>
                <img
                  alt={vocabId}
                  className="vocabImage"
                  data-zoomurl={inBuilder ? undefined : textContent}
                  src={textContent}
                />
              </div>
            </div>
          ) : (
            <div
              className={styles.textarea}
              dangerouslySetInnerHTML={{ __html: textContent }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TextArea;
